/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class PropertyDemandsAPI extends ApiClient {
  constructor() {
    super('property_demands', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  listForContact(contactId, params = {}) {
    const path = resourcePath(
      this.accountScopedPath(),
      'contacts',
      contactId,
      'property_demands'
    );
    return axios.get(withQuery(path, params), requestConfig());
  }

  createForContact(contactId, payload = {}) {
    const path = resourcePath(
      this.accountScopedPath(),
      'contacts',
      contactId,
      'property_demands'
    );
    return axios.post(path, { property_demand: payload }, requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  update(id, payload = {}) {
    return axios.patch(
      resourcePath(this.url, id),
      { property_demand: payload },
      requestConfig()
    );
  }

  pause(id) {
    return this.command(id, 'pause');
  }

  resume(id) {
    return this.command(id, 'resume');
  }

  close(id, payload = {}) {
    return this.command(id, 'close', payload);
  }

  supersede(id, payload = {}) {
    return this.command(id, 'supersede', payload);
  }

  recomputeMatches(id) {
    return this.command(id, 'recompute_matches');
  }

  redispatchAlerts(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'redispatch_alerts'),
      payload,
      requestConfig()
    );
  }

  bulkAction(operation, propertyDemandIds = [], payload = {}) {
    return axios.post(
      resourcePath(this.url, 'bulk_action'),
      {
        operation,
        property_demand_ids: propertyDemandIds,
        property_demand: payload,
      },
      requestConfig()
    );
  }

  command(id, action, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, action),
      Object.keys(payload).length ? { property_demand: payload } : {},
      requestConfig()
    );
  }

  accountScopedPath() {
    return this.url.replace(/\/property_demands$/, '');
  }
}

export default new PropertyDemandsAPI();
